import { createBrowserRouter, type RouteObject } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { Outlet } from 'react-router';
import { LoginPage } from 'business/auth/pages/login';
import { ProtectedRoute } from './protected-route';
import { AnonymousRoute } from './anonymous-route';
import { SessionInfoPage } from 'business/auth/pages/session-info';
import { Routes } from './constants';
import { HomePage } from 'business/home';
import { ReceiptPage } from 'business/receipt';
import { ReceiptChooseSegmentStatusPage } from 'business/receipt/pages/choose-segment-status';
import { ReceiptSuccessPage } from 'business/receipt/pages/success';
import { SettingsSegmentConfigPage } from 'business/settings/pages/segment-config';
import { TunnelPage } from 'business/tunnel/pages/ring-scan';
import { ReceiptRepairPendingPage } from 'business/receipt/pages/repair-pending';
import { ReceiptRepairPage } from 'business/receipt/pages/repair';
import { ErrorBoundary } from 'business/router/error-boundary';
import { RingCompletePage } from 'business/tunnel/pages/ring-complete';

const anonymousRoutes: RouteObject[] = [
  {
    path: Routes.Login,
    element: (
      <AnonymousRoute>
        <LoginPage />
      </AnonymousRoute>
    ),
  },
];

const protectedRoutes: RouteObject[] = [
  {
    path: Routes.App,
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.SessionInfo,
    element: (
      <ProtectedRoute>
        <SessionInfoPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.SettingsSegmentConfig,
    element: (
      <ProtectedRoute>
        <SettingsSegmentConfigPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.Receipt,
    element: (
      <ProtectedRoute>
        <ReceiptPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.ReceiptChooseSegmentStatus,
    element: (
      <ProtectedRoute>
        <ReceiptChooseSegmentStatusPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.ReceiptSuccess,
    element: (
      <ProtectedRoute>
        <ReceiptSuccessPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.ReceiptRepair,
    element: (
      <ProtectedRoute>
        <ReceiptRepairPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.ReceiptRepairPending,
    element: (
      <ProtectedRoute>
        <ReceiptRepairPendingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.Tunnel,
    element: (
      <ProtectedRoute>
        <TunnelPage />
      </ProtectedRoute>
    ),
  },
  {
    path: Routes.TunnelRingComplete,
    element: (
      <ProtectedRoute>
        <RingCompletePage />
      </ProtectedRoute>
    ),
  },
];

const routes: RouteObject[] = [
  {
    element: <Outlet />,
    children: [...anonymousRoutes, ...protectedRoutes],
    ErrorBoundary: ErrorBoundary,
  },
];

export const Router = () => {
  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
};
